// App hook - re-export context
import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

export function useApp() {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useApp must be used within an AppProvider');
    }
    return context;
}

export default useApp;
